webpackJsonp([20544360166589],{

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(3);
	
	var _marketing = __webpack_require__(8);
	
	var _blog = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overview = function (_React$Component) {
	  _inherits(Overview, _React$Component);
	
	  function Overview(props) {
	    _classCallCheck(this, Overview);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Overview.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'DocPage' },
	      _react2.default.createElement(_components.StripeBG, { bg2: "white", style: 'purple' }),
	      _react2.default.createElement(_marketing.Navbar, { className: 'grid-restrain' }),
	      _react2.default.createElement(
	        'section',
	        { className: 'grid-restrain grid-row full-8' },
	        _react2.default.createElement(_blog.DocToc, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'content markdown-doc grid-item' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title' },
	            'Project Groups and Permissions'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'ol',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Project permissions are found in the individual project settings page, and project groups are in the "manage projects" settings page.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1533096656/docs/groups%20and%20permissions/Screen_Shot_2018-07-31_at_11.10.09_PM.png' })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'You can set view and edit rights.  Edit encompasses creating/updating/deleting all resources within a project.  For full access, a user must be a viewer and an editor.  No permissions set means the project is public.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1533089963/updates/1.3.2/groups.png' })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'If you\'re the orgs owner account, you\'ll have access to view and edit all projects in case someone accidentally locks themselves or you out of a project.'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Overview;
	}(_react2.default.Component);
	
	exports.default = Overview;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-doc-project-groups-js-0f6f86f0511c59ccaa5b.js